export default {
  env: 'qa',
  kibanaApi: 'https://api-support-test.xfinity.com/logger/',
  apis: {
    ssm: 'https://api-staging.sc.xfinity.com',
  },
  oauthOptions: {
    clientId: 'mtm-account-change-dev',
    idmClientId: 'dss-refund-preprod',
    authorizeUrl: 'https://oauth-st.xfinity.com/oauth/authorize',
  },
  constants: {
    hintCookieKey: 'r-s-hint',
    accountContextCookieKey: 'xfin_s_ctx',
  },
};
